import { CONFIGS } from './constants';

const ZHL_CALC = 'zhlAffordabilityCalculator';

export const initCalculatorConfigs = env => {
    window[ZHL_CALC] = {
        env,
        ...CONFIGS[env],
    };
};

export const getConfigs = () => {
    if (!window?.[ZHL_CALC]) {
        // eslint-disable-next-line no-console
        console.error('zhl affordability calculator is not initialized yet');
        return {};
    }
    return window[ZHL_CALC];
};
